<div class="user-authorization">
    <div class="ua-inner" *ngIf="userGroup && userGroup.managableLocations">
        <header>
            <div class="header-left">
                <div class="group-name"><input type="text" [(ngModel)]="userGroup.name" (blur)="saveConfigChange()" /></div>
            </div>
            <div class="header-right">
                <div class="default-toggle">
                    <app-quick-toggle
                        [label]="'Default New Users to this Group'"
                        [(datapoint)]="userGroup.default"
                        (toggled)="saveConfigChange()"
                    ></app-quick-toggle>
                </div>
                <div class="close" (click)="close()"></div>
            </div>
        </header>

        <div class="grid-scroll" (mouseleave)="clearHover()">
            <table>
                <thead>
                    <tr>
                        <th class="corner">Permission</th>
                        <th class="loc-header" *ngFor="let location of userGroup.managableLocations; let c = index"
                            [class.hl]="c === hoverCol" [class.inactive]="location.active !== true">
                            <div class="loc-name">{{location.name}}</div>
                            <div class="loc-inactive" *ngIf="location.active !== true">inactive</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let section of sections">
                        <tr class="section-row">
                            <th class="section-label">{{section.name}}</th>
                            <td class="section-fill" [attr.colspan]="userGroup.managableLocations.length"></td>
                        </tr>

                        <tr *ngFor="let permission of section.permissions">
                            <!-- Global permission: one full-width cell (locationId null grant) -->
                            <ng-container *ngIf="!permission.locationSpecific">
                                <th class="permission-name" [class.hl]="hoverPermission === permission"
                                    (click)="toggleAuthorization('general', permission.key)"
                                    [title]="permission.description || ''">
                                    {{permission.name}}
                                </th>
                                <td class="cell global-cell"
                                    [attr.colspan]="userGroup.managableLocations.length"
                                    [class.on]="isAuthorized('general', permission.key)"
                                    [class.hl]="hoverPermission === permission"
                                    (mouseenter)="setHover(permission, -1)"
                                    (click)="toggleAuthorization('general', permission.key)">
                                    <!-- Sticky mark: stays just right of the frozen permission
                                         column so the state is visible at any horizontal scroll. -->
                                    <span class="mark" [class.off]="!isAuthorized('general', permission.key)">{{isAuthorized('general', permission.key) ? '&#10003;' : '&#10007;'}}</span>
                                </td>
                            </ng-container>

                            <!-- Per-location permission: one cell per manageable location -->
                            <ng-container *ngIf="permission.locationSpecific">
                                <th class="permission-name" [class.hl]="hoverPermission === permission"
                                    (click)="toggleAuthorizationAllLocations(permission.key)"
                                    [title]="permission.description || 'Toggle every location'">
                                    {{permission.name}}
                                    <span *ngIf="grantedCount(permission) > 0" class="count"
                                          [class.partial]="grantedCount(permission) < activeLocationCount()">
                                        {{grantedCount(permission) === activeLocationCount() ? 'All' : grantedCount(permission) + '/' + activeLocationCount()}}
                                    </span>
                                </th>
                                <td *ngFor="let location of userGroup.managableLocations; let c = index" class="cell"
                                    [class.hl]="hoverPermission === permission || c === hoverCol"
                                    [class.on]="isAuthorized(location._id, permission.key)"
                                    [class.inactive-col]="location.active !== true"
                                    (mouseenter)="setHover(permission, c)"
                                    (click)="toggleAuthorization(location._id, permission.key)">
                                    <span class="mark" [class.off]="!isAuthorized(location._id, permission.key)">{{isAuthorized(location._id, permission.key) ? '&#10003;' : '&#10007;'}}</span>
                                </td>
                            </ng-container>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

    </div>
</div>
